import DeviceUnknown from '@material-ui/icons/DeviceUnknown';
import Autorenew from '@material-ui/icons/Autorenew';
import TouchApp from '@material-ui/icons/TouchApp';
import Speed from '@material-ui/icons/Speed';
import ScreenRotation from '@material-ui/icons/ScreenRotation';
import MusicNote from '@material-ui/icons/MusicNote';
import WbSunny from '@material-ui/icons/WbSunny';
import ColorLens from '@material-ui/icons/ColorLens';
import DirectionsRailway from '@material-ui/icons/DirectionsRailway';
import KeyboardTab from '@material-ui/icons/KeyboardTab';

export default {
  UNKNOWN: DeviceUnknown,
  BASIC_MOTOR: Autorenew,
  TRAIN_MOTOR: DirectionsRailway,
  LED_LIGHTS: WbSunny,
  BOOST_LED: WbSunny,
  WEDO2_TILT: ScreenRotation,
  WEDO2_DISTANCE: KeyboardTab,
  BOOST_DISTANCE: KeyboardTab,
  BOOST_TACHO_MOTOR: Autorenew,
  BOOST_MOVE_HUB_MOTOR: Autorenew,
  BOOST_TILT: ScreenRotation,
  DUPLO_TRAIN_BASE_MOTOR: DirectionsRailway,
  DUPLO_TRAIN_BASE_SPEAKER: MusicNote,
  DUPLO_TRAIN_BASE_COLOR: ColorLens,
  DUPLO_TRAIN_BASE_SPEEDOMETER: Speed,
  CONTROL_PLUS_LARGE_MOTOR: Autorenew,
  CONTROL_PLUS_XLARGE_MOTOR: Autorenew,
  POWERED_UP_REMOTE_BUTTON: TouchApp,
  CONTROL_PLUS_ACCELEROMETER: ScreenRotation,
  CONTROL_PLUS_GYRO: ScreenRotation,
  CONTROL_PLUS_TILT: ScreenRotation,
};
